/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateTeacherRequest,
  GetAttendanceLogRequest,
  GetTeacherCalendarRequest,
  GetTeacherResponse,
  LogAttendanceRequest,
  PaginatedResultOfGetAttendanceLogResponse,
  PaginatedResultOfGetTeacherResponse,
  Result,
  ResultOfCreateTeacherResponse,
  ResultOfLogAttendanceResponse,
  SearchQueryRequest,
  TeacherCalendar,
  UpdateAttendanceLogRequest,
  UpdateTeacherRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateTeacherRequestFromJSON,
    CreateTeacherRequestToJSON,
    GetAttendanceLogRequestFromJSON,
    GetAttendanceLogRequestToJSON,
    GetTeacherCalendarRequestFromJSON,
    GetTeacherCalendarRequestToJSON,
    GetTeacherResponseFromJSON,
    GetTeacherResponseToJSON,
    LogAttendanceRequestFromJSON,
    LogAttendanceRequestToJSON,
    PaginatedResultOfGetAttendanceLogResponseFromJSON,
    PaginatedResultOfGetAttendanceLogResponseToJSON,
    PaginatedResultOfGetTeacherResponseFromJSON,
    PaginatedResultOfGetTeacherResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateTeacherResponseFromJSON,
    ResultOfCreateTeacherResponseToJSON,
    ResultOfLogAttendanceResponseFromJSON,
    ResultOfLogAttendanceResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    TeacherCalendarFromJSON,
    TeacherCalendarToJSON,
    UpdateAttendanceLogRequestFromJSON,
    UpdateAttendanceLogRequestToJSON,
    UpdateTeacherRequestFromJSON,
    UpdateTeacherRequestToJSON,
} from '../models/index';

export interface ApiTeachersAttendanceLogPostRequest {
    getAttendanceLogRequest: GetAttendanceLogRequest;
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiTeachersIdCalendarPostRequest {
    id: number;
    getTeacherCalendarRequest: GetTeacherCalendarRequest;
    xTenantID?: number;
}

export interface ApiTeachersIdClassesDeleteRequest {
    id: number;
    apiUserTasksGetPageParameter: Array<ApiUserTasksGetPageParameter>;
    xTenantID?: number;
}

export interface ApiTeachersIdClassesPostRequest {
    id: number;
    apiUserTasksGetPageParameter: Array<ApiUserTasksGetPageParameter>;
    xTenantID?: number;
}

export interface ApiTeachersIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTeachersIdLogAttendancePostRequest {
    id: number;
    logAttendanceRequest: LogAttendanceRequest;
    xTenantID?: number;
}

export interface ApiTeachersPostRequest {
    createTeacherRequest: CreateTeacherRequest;
    xTenantID?: number;
}

export interface ApiTeachersPutRequest {
    updateTeacherRequest: UpdateTeacherRequest;
    xTenantID?: number;
}

export interface ApiTeachersScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiTeachersTeacherIdAttendanceLogIdDeleteRequest {
    teacherId: number;
    id: string;
    xTenantID?: number;
}

export interface ApiTeachersTeacherIdLogAttendanceIdPutRequest {
    teacherId: number;
    id: string;
    updateAttendanceLogRequest: UpdateAttendanceLogRequest;
    xTenantID?: number;
}

export interface GetTeacherByIdRequest {
    id: number;
    xTenantID?: number;
}

export interface SearchTeachersRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

/**
 * 
 */
export class TeachersApi extends runtime.BaseAPI {

    /**
     * Returns paginated attendance logs for the given filters. Optional studentIds (max 50) takes precedence over studentId. Empty studentIds is rejected. Members only receive logs for students linked to their account.
     * Get attendance log
     */
    async apiTeachersAttendanceLogPostRaw(requestParameters: ApiTeachersAttendanceLogPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetAttendanceLogResponse>> {
        if (requestParameters['getAttendanceLogRequest'] == null) {
            throw new runtime.RequiredError(
                'getAttendanceLogRequest',
                'Required parameter "getAttendanceLogRequest" was null or undefined when calling apiTeachersAttendanceLogPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/attendance-log`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAttendanceLogRequestToJSON(requestParameters['getAttendanceLogRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetAttendanceLogResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated attendance logs for the given filters. Optional studentIds (max 50) takes precedence over studentId. Empty studentIds is rejected. Members only receive logs for students linked to their account.
     * Get attendance log
     */
    async apiTeachersAttendanceLogPost(requestParameters: ApiTeachersAttendanceLogPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetAttendanceLogResponse> {
        const response = await this.apiTeachersAttendanceLogPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a teacher calendar with classes and appointments based on the specified ID and date range
     * Get teacher calendar
     */
    async apiTeachersIdCalendarPostRaw(requestParameters: ApiTeachersIdCalendarPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeacherCalendar>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersIdCalendarPost().'
            );
        }

        if (requestParameters['getTeacherCalendarRequest'] == null) {
            throw new runtime.RequiredError(
                'getTeacherCalendarRequest',
                'Required parameter "getTeacherCalendarRequest" was null or undefined when calling apiTeachersIdCalendarPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}/calendar`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTeacherCalendarRequestToJSON(requestParameters['getTeacherCalendarRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeacherCalendarFromJSON(jsonValue));
    }

    /**
     * Returns a teacher calendar with classes and appointments based on the specified ID and date range
     * Get teacher calendar
     */
    async apiTeachersIdCalendarPost(requestParameters: ApiTeachersIdCalendarPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeacherCalendar> {
        const response = await this.apiTeachersIdCalendarPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes classes from a teacher by ID
     * Remove teacher classes
     */
    async apiTeachersIdClassesDeleteRaw(requestParameters: ApiTeachersIdClassesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersIdClassesDelete().'
            );
        }

        if (requestParameters['apiUserTasksGetPageParameter'] == null) {
            throw new runtime.RequiredError(
                'apiUserTasksGetPageParameter',
                'Required parameter "apiUserTasksGetPageParameter" was null or undefined when calling apiTeachersIdClassesDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}/classes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['apiUserTasksGetPageParameter']!.map(ApiUserTasksGetPageParameterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Removes classes from a teacher by ID
     * Remove teacher classes
     */
    async apiTeachersIdClassesDelete(requestParameters: ApiTeachersIdClassesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiTeachersIdClassesDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add classes to teacher
     */
    async apiTeachersIdClassesPostRaw(requestParameters: ApiTeachersIdClassesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersIdClassesPost().'
            );
        }

        if (requestParameters['apiUserTasksGetPageParameter'] == null) {
            throw new runtime.RequiredError(
                'apiUserTasksGetPageParameter',
                'Required parameter "apiUserTasksGetPageParameter" was null or undefined when calling apiTeachersIdClassesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}/classes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['apiUserTasksGetPageParameter']!.map(ApiUserTasksGetPageParameterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Add classes to teacher
     */
    async apiTeachersIdClassesPost(requestParameters: ApiTeachersIdClassesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.apiTeachersIdClassesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a teacher by ID
     * Delete teacher
     */
    async apiTeachersIdDeleteRaw(requestParameters: ApiTeachersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a teacher by ID
     * Delete teacher
     */
    async apiTeachersIdDelete(requestParameters: ApiTeachersIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTeachersIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Logs attendance for a specific class session, including student attendance status and optional remarks.
     * Create attendance log
     */
    async apiTeachersIdLogAttendancePostRaw(requestParameters: ApiTeachersIdLogAttendancePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfLogAttendanceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersIdLogAttendancePost().'
            );
        }

        if (requestParameters['logAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'logAttendanceRequest',
                'Required parameter "logAttendanceRequest" was null or undefined when calling apiTeachersIdLogAttendancePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}/log-attendance`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LogAttendanceRequestToJSON(requestParameters['logAttendanceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfLogAttendanceResponseFromJSON(jsonValue));
    }

    /**
     * Logs attendance for a specific class session, including student attendance status and optional remarks.
     * Create attendance log
     */
    async apiTeachersIdLogAttendancePost(requestParameters: ApiTeachersIdLogAttendancePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfLogAttendanceResponse> {
        const response = await this.apiTeachersIdLogAttendancePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create teacher
     */
    async apiTeachersPostRaw(requestParameters: ApiTeachersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateTeacherResponse>> {
        if (requestParameters['createTeacherRequest'] == null) {
            throw new runtime.RequiredError(
                'createTeacherRequest',
                'Required parameter "createTeacherRequest" was null or undefined when calling apiTeachersPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTeacherRequestToJSON(requestParameters['createTeacherRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateTeacherResponseFromJSON(jsonValue));
    }

    /**
     * Create teacher
     */
    async apiTeachersPost(requestParameters: ApiTeachersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateTeacherResponse> {
        const response = await this.apiTeachersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update teacher
     */
    async apiTeachersPutRaw(requestParameters: ApiTeachersPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateTeacherRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTeacherRequest',
                'Required parameter "updateTeacherRequest" was null or undefined when calling apiTeachersPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTeacherRequestToJSON(requestParameters['updateTeacherRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update teacher
     */
    async apiTeachersPut(requestParameters: ApiTeachersPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTeachersPutRaw(requestParameters, initOverrides);
    }

    /**
     * Returns all teachers paginated
     * Get all teachers
     */
    async apiTeachersScrollGetRaw(requestParameters: ApiTeachersScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetTeacherResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetTeacherResponseFromJSON(jsonValue));
    }

    /**
     * Returns all teachers paginated
     * Get all teachers
     */
    async apiTeachersScrollGet(requestParameters: ApiTeachersScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetTeacherResponse> {
        const response = await this.apiTeachersScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an attendance log by ID for a specific teacher
     * Delete attendance log
     */
    async apiTeachersTeacherIdAttendanceLogIdDeleteRaw(requestParameters: ApiTeachersTeacherIdAttendanceLogIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiTeachersTeacherIdAttendanceLogIdDelete().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersTeacherIdAttendanceLogIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{teacherId}/attendance-log/{id}`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an attendance log by ID for a specific teacher
     * Delete attendance log
     */
    async apiTeachersTeacherIdAttendanceLogIdDelete(requestParameters: ApiTeachersTeacherIdAttendanceLogIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTeachersTeacherIdAttendanceLogIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update attendance log for a specific class session, including student attendance status and optional remarks.
     * Update attendance log
     */
    async apiTeachersTeacherIdLogAttendanceIdPutRaw(requestParameters: ApiTeachersTeacherIdLogAttendanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['teacherId'] == null) {
            throw new runtime.RequiredError(
                'teacherId',
                'Required parameter "teacherId" was null or undefined when calling apiTeachersTeacherIdLogAttendanceIdPut().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTeachersTeacherIdLogAttendanceIdPut().'
            );
        }

        if (requestParameters['updateAttendanceLogRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAttendanceLogRequest',
                'Required parameter "updateAttendanceLogRequest" was null or undefined when calling apiTeachersTeacherIdLogAttendanceIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{teacherId}/log-attendance/{id}`;
        urlPath = urlPath.replace(`{${"teacherId"}}`, encodeURIComponent(String(requestParameters['teacherId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAttendanceLogRequestToJSON(requestParameters['updateAttendanceLogRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update attendance log for a specific class session, including student attendance status and optional remarks.
     * Update attendance log
     */
    async apiTeachersTeacherIdLogAttendanceIdPut(requestParameters: ApiTeachersTeacherIdLogAttendanceIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTeachersTeacherIdLogAttendanceIdPutRaw(requestParameters, initOverrides);
    }

    /**
     * Returns a teacher based on the specified ID
     * Get teacher
     */
    async getTeacherByIdRaw(requestParameters: GetTeacherByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeacherResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTeacherById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeacherResponseFromJSON(jsonValue));
    }

    /**
     * Returns a teacher based on the specified ID
     * Get teacher
     */
    async getTeacherById(requestParameters: GetTeacherByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeacherResponse> {
        const response = await this.getTeacherByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated teachers based on search criteria
     * Search teachers
     */
    async searchTeachersRaw(requestParameters: SearchTeachersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetTeacherResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/teachers/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetTeacherResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated teachers based on search criteria
     * Search teachers
     */
    async searchTeachers(requestParameters: SearchTeachersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetTeacherResponse> {
        const response = await this.searchTeachersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
